module.exports = __webpack_public_path__ + "img/join4-2.4b41afcf.svg";